/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-use-before-define */
import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import {
  Paper, Box, Typography, List, Container, CircularProgress,
} from '@mui/material';
import LockClockOutlinedIcon from '@mui/icons-material/LockClockOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import Button from '../../components/Button/Button';
import { colors } from '../../services/colors';

export default function EmailPage() {
  const location = useLocation<any>();
  console.log(location);
  const local = location.pathname;
  return (
    <>
      <Box sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: colors.themePrimary,
        zIndex: 99999999,
        margin: '0px !important',
      }}
      >
        {
            local === '/seccionPage'
              ? <LockClockOutlinedIcon sx={{ fontSize: '50px', marginBottom: '10px', color: 'white' }} /> : <MarkEmailReadOutlinedIcon sx={{ fontSize: '50px', marginBottom: '10px', color: 'white' }} />
        }
        <Typography color="white" style={{ marginBottom: '25px' }}>
          {local === '/seccionPage' ? 'ops, seção finalizada por motivos de segurança realize o seu login novamente' : 'Email confirmado volte ao login para iniciar sua'}
        </Typography>
        <Link to="/Login">
          <Button cor="grey" tonalidade={200}>
            voltar para o login
          </Button>
        </Link>
      </Box>
    </>
  );
}
